<template>
  <div class="home-container">
    
    <header class="hero-banner">
      <div class="hero-content">
        <h1>Construimos soluciones, <span>creamos valor</span></h1>
        <p class="hero-subtitle">
          Diseñamos, construimos y mantenemos espacios que impulsan el crecimiento y la eficiencia de tu negocio.
        </p>
        <div class="cta-buttons">
          <router-link to="/servicios" class="cta-button">Conoce nuestros servicios <i class="fa-solid fa-arrow-right"></i></router-link>
          <router-link to="/proyectos" class="cta-button-secondary">Ver proyectos <i class="fa-solid fa-arrow-right"></i></router-link>
        </div>
      </div>
      <div class="vacio"></div>
    </header>

    <div class="values-section">
      <div class="value">
        <i class="fa-solid fa-compass-drafting"></i>
        <div class="value-text">
          <strong>DISEÑAMOS</strong>
          <span>CON VISIÓN</span>
        </div>
      </div>
      <div class="value">
        <i class="fa-solid fa-helmet-safety"></i>
        <div class="value-text">
          <strong>CONSTRUIMOS</strong>
          <span>CON CALIDAD</span>
        </div>
      </div>
      <div class="value">
        <i class="fa-solid fa-clipboard-check"></i>
        <div class="value-text">
          <strong>CUMPLIMOS</strong>
          <span>CON RESPONSABILIDAD</span>
        </div>
      </div>
      <div class="value">
        <i class="fa-solid fa-handshake"></i>
        <div class="value-text">
          <strong>ENTREGAMOS</strong>
          <span>CON ORGULLO</span>
        </div>
      </div>
      <div class="value">
        <i class="fa-solid fa-user-gear"></i>
        <div class="value-text">
          <strong>MANTENEMOS</strong>
          <span>CONFIANZA</span>
        </div>
      </div>
    </div>

    <section class="about-section">
      <div class="about-text">
        <p class="section-label">Sobre Tasoar</p>
        <h2>Más que proyectos, <span>construimos relaciones.</span></h2>
        <p class="section-intro">
          En Tasoar, transformamos ideas en soluciones arquitectónicas integrales.
          Nos enfocamos en la calidad, seguridad y cumplimiento en cada etapa del proyecto.
        </p>
        <router-link to="/nosotros" class="cta-button">Conócenos más <i class="fa-solid fa-arrow-right"></i></router-link>
      </div>

      <div class="about-features">
        <div class="feature-item">
          <i class="fa-solid fa-people-group"></i>
          <div class="feature-text">
            <h3>Equipo Especializado</h3>
            <p>Profesionales con experiencia en cada una de nuestras áreas de servicio.</p>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-solid fa-medal"></i>
          <div class="feature-text">
            <h3>Calidad Garantizada</h3>
            <p>Procesos y materiales que aseguran resultados duraderos y funcionales.</p>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-regular fa-clock"></i>
          <div class="feature-text">
            <h3>Cumplimiento Total</h3>
            <p>Entregamos en tiempo y forma, cumpliendo con la normatividad aplicable.</p>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-solid fa-leaf"></i>
          <div class="feature-text">
            <h3>Compromiso Sostenible</h3>
            <p>Impulsamos el ahorro de energía y el cuidado del medio ambiente en cada solución.</p>
          </div>
        </div>
      </div>

      <div class="about-image">
        <img src="/img/casco-home.png" alt="Casco de seguridad Tasoar sobre planos arquitectónicos">
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      formData: {
        nombre: '',
        email: '',
        servicio: 'mantenimiento',
        mensaje: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      console.log("Datos enviados:", this.formData);
      alert(`¡Gracias ${this.formData.nombre}! Hemos recibido tu solicitud sobre ${this.formData.servicio}.`);
      
      this.formData = { nombre: '', email: '', servicio: 'mantenimiento', mensaje: '' };
    }
  }
};
</script>

<style scoped>
/* --- Estilos Generales --- */
.home-container {
  text-align: center;
  color: #333;
}

h1, h2, h3 {
  margin-bottom: 15px;
}

/* --- Estilos del Hero Banner --- */
.hero-banner {
  width: 100%;
  height: 100%;
  position: relative; 
  background-image: url('@/assets/homeBanner.webp');
  background-size: cover;
  background-position: center;
  object-fit: cover;
  color: white;
  padding: 0px;
}

.hero-content {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  max-width: 650px;
  padding: 20px 0px 75px 0px; 
  box-sizing: border-box;      
  margin-left: 80px;
}

.hero-content h1::after {
  content: ""; 
  display: block; 
  width: 80px; 
  height: 4px; 
  background-color: #ffffff; 
  margin-top: 16px; 
}

.vacio{
  width: 60%;
}

h1{
  font-size: 60px;
  color: var(--color-secundary);
  text-transform: uppercase;
  text-align: left;
  text-shadow: 2px 2px #2c2c2cdd;
}

h1 span{
  color: var(--color-text);
}

.hero-subtitle {
  font-size: 25px;
  margin-bottom: 30px;
  text-shadow: 2px 2px #2c2c2cdd;
  text-align: left;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: flex-start; 
}

.cta-button {
  background-color: var(--color-text); 
  color: white;
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.cta-button-secondary {
  background-color: transparent;
  border: 2px solid var(--color-secundary); 
  color: white;
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: var(--color-secundary);
  color: var(--color-primary);
}

.cta-button-secondary:hover {
  background-color: var(--color-secundary);
  color: var(--color-primary);
}

/* ------ */
.values-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  
  max-width: 1200px;
  width: 90%; /* Ajuste responsivo para que no toque los bordes en pantallas medianas */
  margin: 0 auto; /* Centrado horizontal */
  
  /* EL TRUCO PARA FLOTAR: */
  position: relative;
  margin-top: -55px; /* Empuja la barra hacia arriba cubriendo el banner. Ajusta el número según necesites */
  z-index: 10; /* Asegura que quede encima del banner */
  
  /* Diseño de la tarjeta */
  background-color: #ffffff;
  padding: 25px 20px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); /* Sombra suave para dar profundidad */
  box-sizing: border-box;
}

/* Cada bloque individual (Icono + Texto) */
.value {
  display: flex;
  align-items: center;
  gap: 15px; /* Separación entre el ícono y el texto */
  flex: 1;
  justify-content: center;
}

/* Línea divisoria vertical entre los valores (excepto el último) */
.value:not(:last-child) {
  border-right: 1px solid #e0e0e0;
}

/* Estilo del ícono */
.value i {
  font-size: 2.2rem;
  color: var(--color-primary); /* Cambia por tu color de marca */
}

/* Contenedor interno del texto */
.value-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.value-text strong {
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--color-primary);
  letter-spacing: 0.5px;
}

.value-text span {
  font-size: 0.8rem;
  color: #707070;
  font-weight: 500;
}

/* --- Estilos de la Sección Sobre Tasoar --- */
.about-section {
  display: grid;
  grid-template-columns: 1fr 1.3fr 0.9fr;
  align-items: center;
  gap: 40px;
  max-width: 1300px;
  margin: 0 auto;
  padding: 70px 20px;
  text-align: left;
  background-color: #f4f8fc;
}

.section-label {
  color: var(--color-text);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.about-text h2 {
  font-size: 2rem;
  color: var(--color-primary);
  line-height: 1.3;
}

.about-text h2 span {
  color: var(--color-text);
  display: block;
}

.section-intro {
  margin-bottom: 30px;
  color: #555;
  line-height: 1.6;
}

/* Cuadrícula de features (2x2) */
.about-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.feature-item i {
  font-size: 1.8rem;
  color: var(--color-primary);
  margin-top: 4px;
  flex-shrink: 0;
}

.feature-text h3 {
  font-size: 1.05rem;
  color: var(--color-primary);
  margin: 0 0 8px 0;
}

.feature-text p {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* Imagen del casco / planos */
.about-image {
  height: 100%;
  min-height: 320px;
}

.about-image img {
  width: 100%;
  height: 100%;
  min-height: 320px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

/* CSS Grid para las tarjetas */
.services-grid {
  display: flex;       
  flex-wrap: wrap;       
  justify-content: center;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Estilos de las Tarjetas Individuales */
.service-card {
  display: block;              /* Asegura que el enlace se comporte como tarjeta */
  text-decoration: none;       /* Quita subrayado del enlace */
  color: inherit;              /* Evita azul/morado por estados de enlace */
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
  flex: 1 1 300px; 
  max-width: 350px;
}

.service-card:visited {
  color: inherit;              /* Mantiene color consistente tras visitar */
}

.service-card:hover {
  transform: translateY(-10px); /* Efecto de elevación al pasar el mouse */
  text-decoration: none;        /* Sin subrayado en hover */
}

.icon {
  font-size: 3em;
  margin-bottom: 20px;
  color: var(--color-secundary);              /* Color de icono consistente con la marca */
}

.service-card h3 {
  color: #2c3e50;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

/* --- Estilos del CTA Final --- */
.final-cta {
  padding: 80px 20px;
  background-color: #e9ecef;
}

.secondary-button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 25px;
  border: 2px solid var(--color-secundary);
  text-decoration: none;
  color: var(--color-secundary);
  font-weight: bold;
  border-radius: 5px;
  transition: all 0.3s;
}

.secondary-button:hover {
  background-color: var(--color-secundary);
  color: white;
}

/* --- Estilos del Formulario de Contacto --- */
.contact-section {
  padding: 80px 20px;
  background-color: white;
}

.contact-container {
  max-width: 600px;
  margin: 0 auto;
  text-align: left; /* Alineamos etiquetas a la izquierda */
}

.contact-form {
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
  color: #2c3e50;
}

.form-group input, 
.form-group select, 
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
}

.form-group input:focus, 
.form-group select:focus, 
.form-group textarea:focus {
  outline: none;
  border-color: #42b983;
  box-shadow: 0 0 0 3px rgba(66, 185, 131, 0.1);
}

.submit-button {
  width: 100%;
  background-color: var(--color-secundary);
  color: white;
  padding: 15px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
}

.submit-button:hover {
  background-color: var(--color-secundary);
}

/* --- Media Queries para Responsividad --- */
@media (max-width: 1024px) {
  .hero-content {
    width: 60%;
    margin-left: 50px;
  }

  .values-section {
    flex-wrap: wrap;
    row-gap: 25px;
    width: 92%;
  }

  .value {
    flex: 1 1 45%;
  }

  .value:not(:last-child) {
    border-right: none;
  }

  .about-section {
    grid-template-columns: 1fr 1fr;
  }

  .about-image {
    grid-column: 1 / -1;
    min-height: 260px;
  }

  .about-image img {
    min-height: 260px;
  }
}

@media (max-width: 768px) {
  /* Hero Banner */
  .hero-banner {
    padding: 0;
  }

  .hero-content {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    padding: 50px 25px 60px 25px;
  }

  .vacio {
    display: none;
  }

  h1 {
    font-size: 32px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .cta-button, .cta-button-secondary {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Valores */
  .values-section {
    margin-top: -30px;
    padding: 20px 15px;
  }

  .value {
    flex: 1 1 100%;
    justify-content: flex-start;
  }

  .value:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 15px;
    margin-bottom: 5px;
  }

  /* Sobre Tasoar */
  .about-section {
    grid-template-columns: 1fr;
    padding: 40px 20px;
  }

  .about-features {
    grid-template-columns: 1fr;
  }

  .about-image {
    grid-column: auto;
    order: -1;
    min-height: 220px;
  }

  .about-image img {
    min-height: 220px;
  }

  /* Contacto */
  .contact-section {
    padding: 50px 15px;
  }

  .contact-form {
    padding: 25px;
  }

  .contact-container {
    width: 100%;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 26px;
  }

  .hero-content {
    padding: 40px 20px 45px 20px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .value i {
    font-size: 1.8rem;
  }
}

/* --- Footer --- */
.site-footer {
  background-color: #333;
  color: white;
  padding: 50px 20px 20px;
  margin-top: 0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
  text-align: left;
}

.footer-col {
  flex: 1 1 250px;
}

.footer-col h3 {
  color: var(--color-secundary);
  margin-bottom: 15px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
}

.footer-col ul li {
  margin-bottom: 8px;
}

.footer-col ul li a {
  color: #ddd;
  text-decoration: none;
}

.footer-col ul li a:hover {
  color: var(--color-secundary);
}

.footer-bottom {
  border-top: 1px solid #555;
  margin-top: 40px;
  padding-top: 20px;
  font-size: 14px;
  color: #aaa;
}
</style>